// extracted by mini-css-extract-plugin
module.exports = {"title":"UserAgreement_title__ydbxy","ol":"UserAgreement_ol__zcK9B","li":"UserAgreement_li__XQ-Zo"};